export const apiEndpointUrl = import.meta.env.VITE_API_ENDPOINT_URL!
export const xApiKey = import.meta.env.VITE_X_API_KEY!
export const appEnvironment = import.meta.env.VITE_ENV!
export const appEndpointUrl = import.meta.env.VITE_ENDPOINT_URL!

if (!apiEndpointUrl) throw new Error('apiEndpointUrl not found in env')
if (!xApiKey) throw new Error('xApiKey not found in env')
if (!appEnvironment) throw new Error('appEnvironment not found in env')
if (!appEndpointUrl) throw new Error('appEndpointUrl not found in env')
